import { reduxForm, submit } from 'redux-form';
import { debounce, isEqual } from 'lodash';
import { compose, withProps } from 'recompose';
import { DEFAULT_DEBOUNCE_TIME } from '../constants';

export default ({ isAutoSubmit, debounceOptions = {}, ...reduxFormOptions } = {}) => {
  const debouncedSubmit = debounce(
    (value, dispatch, props, prevValues) => {
      if (props.pristine || isEqual(value, prevValues)) {
        return; // submit only if form is changed by user @sinslav
      }
      setTimeout(() => dispatch(submit(props.form))); // Putting submit into next event loop to let RF validation update sync errors @sinslav;
    },
    DEFAULT_DEBOUNCE_TIME,
    { leading: true, ...debounceOptions },
  );

  const reduxFormConfig = { ...reduxFormOptions };
  if (isAutoSubmit) {
    reduxFormConfig.onChange = debouncedSubmit; // submitting form each single time it changes internally @sinslav
  }

  return compose(
    reduxForm(reduxFormConfig),
    withProps({
      flushSubmit: debouncedSubmit.flush,
      cancelSubmit: debouncedSubmit.cancel,
    }),
  );
};
